import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import { SiShopware } from 'react-icons/si';
import { MdOutlineCancel } from 'react-icons/md';
import { TooltipComponent } from '@syncfusion/ej2-react-popups';
import { useStateContext } from '../contexts/ContextProvider';
import { links } from '../data/dummy';
import { BiMobile } from 'react-icons/bi';
const Sidebar = () => {

  const {activeMenu, setActiveMenu, screenSize, setScreenSize, currentColor} = useStateContext();
  const activeLink = 'flex items-center gap-5 pl-4 pt-3 pb-2.5 rounded-lg  text-white  text-md m-2';
  const normalLink = 'flex items-center gap-5 pl-4 pt-3 pb-2.5 rounded-lg text-md text-gray-700 dark:text-gray-200 dark:hover:text-black hover:bg-light-gray m-2';

  const handleCloseSideBar = () => {
    if (activeMenu && screenSize <= 900) {
      setActiveMenu(false) 
      // To close the sidebar upon calling of the function
      // upon click of the logo or any sidebar menu items, and check
      // whether those were clicked very screensize <900 i.e on a mobile,
      // thus make it invisible after clicking those items to make space
    }
  }
  return (
    // Overall sidebar div, overflow auto displays sidebar, so on hover display sidebar
    <div className='ml-3 h-screen md:overflow-hidden overflow-auto 
    md:hover:overflow-auto pb-10'>
      {
        activeMenu && (
          <>
          {/* Ṣhoppy Logo */}
            <div className='flex justify-between items-center'>

              <Link to="/" onClick={handleCloseSideBar}
              className='items-center gap-3 ml-3 mt-4 flex text-xl font-extrabold
              tracking-tight dark:text-white text-slate-900'>
                <SiShopware/> <span>Shopee</span>
              </Link>

              {/*The cancel button */}
              <TooltipComponent content="Menu" position='BottomCenter'>
                <button type='button' 
                onClick={() => setActiveMenu(!activeMenu) }
                className='text-xl rounded-full p-3 hover:bg-light-gray mt-4
                md:hidden block'>
                  <MdOutlineCancel/>
                </button>
              </TooltipComponent>
            </div>

            {/* For Sidebar items */}

            <div className='mt-10'>
              {
                links.map((item)=>(
                  <div key={item.title}>
                    <p className='text-gray-400 m-3 mt-4 uppercase'>
                        {item.title}
                    </p>
                    {
                      item.links.map((link) => (
                        <NavLink to={`${link.name}`} key={link.name} 
                        onClick={handleCloseSideBar}
                        style={({ isActive }) => ({
                        backgroundColor: isActive ? currentColor : '',
                         })}
                        className={({isActive}) => isActive ? activeLink : normalLink }>
                          {link.icon}
                          <span className='capitalize'>
                            {link.name}
                          </span> 
                        </NavLink>
                      ))
                    }
                  </div>
                ))
              }
            </div>
          </>
        )
      }  
    </div>
  )
}

export default Sidebar
